export enum BugSnagTrackingEvent {
  OnSuccessCallback = 'TinkWidgetOnSuccessCallbackTriggered',
  OnSuccessInternalCallback = 'TinkWidgetOnSuccessInternalCallbackTriggered',
}
